import React, { Component } from "react";
import PropTypes from "prop-types";
import Attribute from "../Attribute";
import { withTheme } from "styled-components";
import Guidelines from "@sisuwellness/utilities/Guidelines";
import { withTranslation } from "react-i18next";

class Qrisk extends Component {
    static displayName = "Qrisk";
    static propTypes = {
        t: PropTypes.func,
        theme: PropTypes.any.isRequired,
        score: PropTypes.number,
        date: PropTypes.string
    };

    render() {
        const { t, score, theme, date, ...rest } = this.props;
        let guideline = null;
        let guidelineStyle = null;
        let isDisabled = true;
        if (score !== null) {
            try {
                guideline = Guidelines.Qrisk.GetGuideline(score);
                guidelineStyle = theme.guidelines.Qrisk[guideline.key];
                isDisabled = false;
            } catch (err) {
                // do nothing
            }
        }

        return (
            <Attribute
                {...rest}
                colour={guidelineStyle ? guidelineStyle.flat.hex : null}
                gradientCSS={guidelineStyle ? guidelineStyle.gradientCSS : null}
                guidelineRating={guideline ? t(guideline.label) : null}
                guidelineRatingInfo={guideline ? t(guideline.rangeInfo) : null}
                title={t("web_components.cards.attributes.qrisk.title")}
                date={date}
                primaryStatUnit={"%"}
                primaryStatValue={isDisabled ? null : score.toFixed(1)}
                icon={theme.icons.types.qrisk}
                t={t}
            />
        );
    }
}

export default withTranslation()(withTheme(Qrisk));
